import { IDocs } from '_core/types';
import { memberInfoApi as API } from '../Apis';
import { smilesMaskPhone, smilesMaskEmail } from '_core/helpers/validations';
import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';

export const MemberInfoDocs: IDocs = {
  title: 'MemberInfo',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.memberInfo',
};

const prepareCall = () => API.call.get();

const handleSucessFinalResponseFunction = (data: any) => {
  const dataResponse = data;
  if (typeof dataResponse.verifiedPhoneNumber === 'string')
    dataResponse.verifiedPhoneNumber =
      data?.verifiedPhoneNumber === 'Y' ? true : false;

  if (typeof dataResponse.verifiedPhoneNumber === 'string')
    dataResponse.verifiedEmail = data?.verifiedEmail === 'Y' ? true : false;

  dataResponse.phoneNumberMask = null;
  if (
    dataResponse?.phoneDDINumber &&
    dataResponse?.phoneDDDNumber &&
    dataResponse?.phoneNumber &&
    dataResponse?.phoneNumber?.length > 4
  ) {
    dataResponse.phoneNumberMask = smilesMaskPhone(
      dataResponse.phoneDDINumber,
      dataResponse.phoneDDDNumber,
      dataResponse.phoneNumber,
    );
  }

  if (dataResponse?.email) {
    dataResponse.emailMask = smilesMaskEmail(dataResponse.email) || null;
  }

  return dataResponse;
};

export const MemberInfoMachine = GenericMachine(
  prepareCall,
  {
    docs: MemberInfoDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
  },
);
